
import confetti from 'canvas-confetti';

export const ATTENTION_ANIMATIONS = {
  // Subtle pulse to draw eye
  pulse: {
    scale: [1, 1.03, 1],
    transition: { duration: 2, repeat: Infinity, ease: "easeInOut" }
  },
  
  // Gentle glow for new features
  glow: {
    boxShadow: [
      "0 0 0px rgba(197, 160, 89, 0)",
      "0 0 20px rgba(197, 160, 89, 0.5)",
      "0 0 0px rgba(197, 160, 89, 0)"
    ],
    transition: { duration: 3, repeat: Infinity }
  },
  
  // Shimmer for premium features
  shimmer: {
    backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
    transition: { duration: 3, repeat: Infinity, ease: "linear" }
  }
};

export const FEEDBACK_ANIMATIONS = {
  // Success confirmation
  success: {
    scale: [1, 1.2, 1],
    rotate: [0, 5, -5, 0],
    transition: { duration: 0.6, ease: "backOut" }
  },
  
  // Error shake
  error: {
    x: [0, -10, 10, -10, 10, 0],
    transition: { duration: 0.5 }
  },
  
  // Loading pulse
  loading: {
    scale: [1, 1.1, 1],
    opacity: [1, 0.7, 1],
    transition: { duration: 1.5, repeat: Infinity }
  }
};

export const TRANSITION_ANIMATIONS = {
  // Page transitions
  pageEnter: {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
    transition: { duration: 0.3 }
  },
  
  // Modal transitions
  modalEnter: {
    initial: { opacity: 0, scale: 0.9 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.9 },
    transition: { type: "spring", damping: 25, stiffness: 300 }
  },
  
  // Card hover
  cardHover: {
    y: -8,
    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.2)",
    transition: { duration: 0.2 }
  }
};

export const DELIGHT_ANIMATIONS = {
  // Confetti burst
  confetti: () => {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      colors: ['#C5A059', '#f59e0b', '#ef4444']
    });
  },
  
  // Celebration
  celebrate: {
    scale: [1, 1.5, 1],
    rotate: [0, 360],
    transition: { duration: 0.8, ease: "backOut" }
  }
};
